import { CustomerType } from "@origin-digital/platform-enums";
import { BasicJSONSchema, IMcAppType, NavFlow, Tab } from "../mcApp.types";

// originAccountId is the Origin account id (User DB), passed as a query param.
// It is intentionally NOT the Kraken accountNumber CommonParameter.
const originAccountId: BasicJSONSchema = {
  description: "Origin account id (User DB)",
  type: "string",
};

export const batteryVppEnrolment: IMcAppType = {
  name: "batteryVppEnrolment",
  path: "/my/service/battery/vpp-enrolment",
  parameters: {
    required: ["originAccountId"],
    properties: { originAccountId },
  },
  description: "Battery VPP enrolment focus flow",
  navFlow: NavFlow.FOCUS,
  title: "Battery Charge",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "batteryVppEnrolment",
    customerType: CustomerType.kraken,
  },
};
